import { render, staticRenderFns } from "./CourseSectionEditModal.vue?vue&type=template&id=6dc8833e&"
import script from "./CourseSectionEditModal.vue?vue&type=script&lang=js&"
export * from "./CourseSectionEditModal.vue?vue&type=script&lang=js&"
import style0 from "./CourseSectionEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports